<template>
  <div class="row">
    <div class="col-md-12">
      <div class="row">
        <div
          class="col-md-3"
          v-if="client"
        >
          <div class="row">
            <div
              class="col-md-12 margin-bottom cursor-pointer"
              v-viewer
            >
              <img
                :src="borrower_photo"
                alt="take_photo_with_id"
                @error="(e) => {e.target.src='/img/take_photo_with_id.jpg'}"
                class="img-thumbnail img-responsive"
              >
            </div>
            <div
              class="col-md-12 margin-bottom cursor-pointer"
              v-viewer
            >
              <img
                :src="borrower_national_id_photo"
                alt="national_id_card"
                @error="(e) => {e.target.src='/img/national_id_card.jpg'}"
                class="img-thumbnail img-responsive"
              >
            </div>
            <template v-if="client.type === 'Pawn' || client.type === 'Purchasing'">
              <div
                class="col-md-12 cursor-pointer"
                v-viewer
              >
                <img
                  :src="borrower_employment_card_photo"
                  alt="employee_card"
                  @error="(e) => {e.target.src='/img/employee_card.png'}"
                  class="img-thumbnail img-responsive"
                >
              </div>
            </template>
          </div>
        </div>
        <div class="col-md-9">
          <div class="row">
            <div class="col-md-12 margin-bottom">
              <div class="box box-primary">
                <div class="box-header with-border">
                  <h3 class="box-title">
                    {{ $t('label.information') }}
                  </h3>
                  <div class="box-tools">
                    <button
                      data-toggle="modal"
                      data-target="#editLoginAccountModal"
                      class="btn btn-primary btn-sm margin-right-5"
                    >
                      <i class="fa fa-edit" /> {{ $t('string.edit_login_account') }}
                    </button>
                    <button
                      @click="$router.push({name: 'list-client'})"
                      class="btn btn-default btn-sm btn-back"
                    >
                      {{ $t('button.back') }}
                    </button>
                  </div>
                </div>
                <div class="box-body">
                  <div class="table-responsive">
                    <table
                      class="table table-bordered table-striped"
                      v-if="client"
                    >
                      <tbody>
                        <tr>
                          <th>{{ $t('label.clientId') }}</th>
                          <td class="text-muted">
                            : {{ client.search_borrower_id }}
                          </td>
                          <td class="text-bold">
                            {{ $t('string.login_account') }}
                          </td>
                          <td>
                            <template v-if="user">
                              (UE: {{
                                user.username ? user.username : $t('string.na')
                              }}/TEL:{{ user.phone ? user.phone : $t('string.na') }})
                            </template>
                            <template v-else>
                              {{ $t('string.na') }}
                            </template>
                          </td>
                        </tr>
                        <tr>
                          <th>{{ $t('label.name') }}</th>
                          <td class="text-muted">
                            : {{ client.name }} {{ client.last_name }}
                          </td>
                          <th>{{ $t('label.nationalIdNumber') }}</th>
                          <td class="text-muted">
                            : {{ client.national_id_number }}
                          </td>
                        </tr>
                        <tr>
                          <th>{{ $t('label.phone') }}</th>
                          <td class="text-muted">
                            : {{ client.phone }}
                          </td>
                          <th>{{ $t('label.email') }}</th>
                          <td class="text-muted">
                            : {{ client.email }}
                          </td>
                        </tr>
                        <tr>
                          <th>{{ $t('fields.nationalIdNumber') }}</th>
                          <td class="text-muted">
                            : {{ client.national_id_number || $t('string.na') }}
                          </td>
                          <th>{{ $t('fields.maritalStatus') }}</th>
                          <td class="text-muted">
                            : {{ client.marital_status || $t('string.na') }}
                          </td>
                        </tr>
                        <tr>
                          <th>{{ $t('label.gender') }}</th>
                          <td class="text-muted">
                            : {{ client.gender }}
                          </td>
                          <th>{{ $t('label.dateOfBirth') }}</th>
                          <td class="text-muted">
                            : {{ client.date_of_birth }}
                          </td>
                        </tr>
                        <tr>
                          <th>{{ $t('fields.street_number') }}</th>
                          <td class="text-muted">
                            : {{ client.street_number || $t('string.na') }}
                          </td>
                          <th>{{ $t('label.homeNumber') }}</th>
                          <td class="text-muted">
                            : {{ client.home_number || $t('string.na') }}
                          </td>
                        </tr>
                        <tr>
                          <th>{{ $t('label.village') }}</th>
                          <td class="text-muted">
                            : {{ client.village || $t('string.na') }}
                          </td>
                          <th>{{ $t('label.commune') }}</th>
                          <td class="text-muted">
                            : {{ client.commune || $t('string.na') }}
                          </td>
                        </tr>
                        <tr>
                          <th>{{ $t('label.district') }}</th>
                          <td class="text-muted">
                            : {{ client.district || $t('string.na') }}
                          </td>
                          <th>{{ $t('label.province') }}</th>
                          <td class="text-muted">
                            : {{ client.province || $t('string.na') }}
                          </td>
                        </tr>
                        <tr>
                          <th>{{ $t('fields.howLongHaveBeenLivingThere') }}</th>
                          <td class="text-muted">
                            : {{ client.how_long_have_been_living_there || $t('string.na') }}
                          </td>
                          <th>{{ $t('fields.borrowEducation') }}</th>
                          <td class="text-muted">
                            :
                            {{ client.borrow_education ? client.borrow_education.name : $t('string.na') }}
                          </td>
                        </tr>
                        <tr>
                          <th>{{ $t('fields.schoolName') }}</th>
                          <td class="text-muted">
                            : {{ client.school_name || $t('string.na') }}
                          </td>
                          <th>{{ $t('fields.graduateYear') }}</th>
                          <td class="text-muted">
                            : {{ client.graduate_year || $t('string.na') }}
                          </td>
                        </tr>
                        <tr>
                          <th>{{ $t('fields.studyMajor') }}</th>
                          <td class="text-muted">
                            : {{ client.study_major || $t('string.na') }}
                          </td>
                          <th>{{ $t('fields.howDidYouHearAboutUs?') }}</th>
                          <td class="text-muted">
                            : {{ client.source_of_information || $t('string.na') }}
                            <template v-if="client.source_of_information === 'Other' && client.source_of_information_other">
                              {{ client.source_of_information_other }}
                            </template>
                          </td>
                        </tr>
                        <tr>
                          <th>{{ $t('fields.membership') }}</th>
                          <td class="text-muted">
                            <template v-if="client.membership">
                              {{ client.membership['name_' + $i18n.locale] }}
                            </template>
                            <template v-else>
                              {{ $t('string.na') }}
                            </template>
                          </td>
                          <th>{{ $t('fields.borrower_status') }}</th>
                          <td class="text-muted">
                            <template v-if="client.borrower_status">
                              <div style="display: flex; align-items: center;">
                                <VMenu
                                  v-if="borrower_status.instruction"
                                >
                                  <button
                                    class="btn btn-xs btn-default"
                                    style="border-radius: 50%;"
                                  >
                                    <i class="fa fa-info-circle" />
                                  </button>

                                  <template #popper>
                                    <div
                                      style="padding: 1.75rem;"
                                      v-html="borrower_status.instruction"
                                    />
                                  </template>
                                </VMenu>
                                <div style="margin-left: 0.75rem;">
                                  {{ client.borrower_status }}
                                </div>
                              </div>
                            </template>
                            <template v-else>
                              {{ $t('string.na') }}
                            </template>
                          </td>
                        </tr>
                        <tr>
                          <th>{{ $t('fields.occupation') }}</th>
                          <td class="text-muted">
                            : {{ client.occupation || $t('string.na') }}
                          </td>
                          <th>{{ $t('label.companyName') }}</th>
                          <td class="text-muted">
                            : {{ client.company_name || $t('string.na') }}
                          </td>
                        </tr>
                        <tr>
                          <th>{{ $t('label.grossMonthlyIncome') }}</th>
                          <td class="text-muted">
                            : {{ client.gross_monthly_income || $t('string.na') }}
                          </td>
                          <th>{{ $t('label.companyContactName') }}</th>
                          <td class="text-muted">
                            : {{ client.company_contact_name || $t('string.na') }}
                          </td>
                        </tr>
                        <tr>
                          <th>{{ $t('label.companyType') }}</th>
                          <td class="text-muted">
                            : {{ client.company_type || $t('string.na') }}
                          </td>
                          <th>{{ $t('label.companyContactPhone') }}</th>
                          <td class="text-muted">
                            : {{ client.company_contact_phone || $t('string.na') }}
                          </td>
                        </tr>
                        <tr>
                          <th>{{ $t('label.relativeName') }}</th>
                          <td class="text-muted">
                            : {{ client.relative_name || $t('string.na') }}
                          </td>
                          <th>{{ $t('label.relativeContactPhone') }}</th>
                          <td class="text-muted">
                            : {{ client.relative_contact_phone || $t('string.na') }}
                          </td>
                        </tr>
                        <tr>
                          <th>{{ $t('label.relativeType') }}</th>
                          <td class="text-muted">
                            : {{ client.relative_type || $t('string.na') }}
                            <template v-if="client.relative_type === 'Other' && client.relative_type_other">
                              ({{ client.relative_type_other }})
                            </template>
                          </td>
                          <th>{{ $t('label.sourceOfInformation') }}</th>
                          <td class="text-muted">
                            : {{ client.source_of_information || $t('string.na') }}
                            <template v-if="client.source_of_information === 'Other' && client.source_of_information_other">
                              ({{ client.source_of_information_other }})
                            </template>
                          </td>
                        </tr>
                        <tr>
                          <th>{{ $t('label.bankName') }}</th>
                          <td class="text-muted">
                            : {{ client.bank_name || $t('string.na') }}
                          </td>
                          <th>{{ $t('label.bankAccountNumber') }}</th>
                          <td class="text-muted">
                            : {{ client.bank_account_number || $t('string.na') }}
                          </td>
                        </tr>
                        <tr>
                          <th>{{ $t('fields.facebookName') }}</th>
                          <td class="text-muted">
                            : {{ client.facebook_name || $t('string.na') }}
                          </td>
                          <th>{{ $t('fields.facebookLink') }}</th>
                          <td class="text-muted">
                            :
                            <template v-if="client.facebook_link">
                              <a
                                :href="client.facebook_link"
                                target="_blank"
                              >{{ client.facebook_link }}</a>
                            </template>
                            <template v-else>
                              {{ $t('string.na') }}
                            </template>
                          </td>
                        </tr>
                        <tr>
                          <th>{{ $t('string.collection_officer') }}</th>
                          <td class="text-muted">
                            :
                            {{ client.collection_officer ? client.collection_officer.name : $t('string.na') }}
                          </td>
                          <th>{{ $t('fields.label.home_type') }}</th>
                          <td class="text-muted">
                            : {{ client.home_type || $t('string.na') }}
                          </td>
                        </tr>
                        <template v-if="client.type === 'Pawn'">
                          <tr>
                            <th>{{ $t('string.typeOfCollateral') }}</th>
                            <td class="text-muted">
                              : {{ client.type_of_collateral || $t('string.na') }}
                              <template v-if="client.type_of_collateral === 'Other' && client.type_of_collateral_other">
                                ({{ client.type_of_collateral_other }})
                              </template>
                            </td>
                            <th />
                            <td class="text-muted" />
                          </tr>
                        </template>
                        <template v-else-if="client.type === 'Purchasing'">
                          <tr>
                            <th>{{ $t('fields.purchaseItem') }}</th>
                            <td class="text-muted">
                              : {{ client.purchase_item || $t('string.na') }}
                              <template v-if="client.purchase_item === 'Other' && client.purchase_item_other">
                                ({{ client.purchase_item_other }})
                              </template>
                            </td>
                            <th>{{ $t('fields.purchasePrice') }}</th>
                            <td class="text-muted">
                              : {{ client.purchase_total_price || $t('string.na') }}
                            </td>
                          </tr>
                        </template>
                        <tr>
                          <th>{{ $t('table.credit_score') }}</th>
                          <td class="text-muted">
                            : {{ client.credit_score || $t('string.na') }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-12">
              <div class="box box-primary">
                <div class="box-header with-border">
                  <h3 class="box-title">
                    {{ $t('label.loanHistory') }}
                  </h3>
                  <div class="box-tools">
                    <button
                      class="btn btn-primary btn-sm"
                      @click="onSyncLoans"
                    >
                      <i class="fa fa-refresh" /> {{ $t('string.syncLoans') }}
                    </button>
                  </div>
                </div>
                <div class="box-body">
                  <table
                    id="loans-table"
                    style="width: 100%"
                    class="table table-hover table-striped table-bordered"
                  >
                    <thead>
                      <tr>
                        <th>{{ $t('table.action') }}</th>
                        <th>{{ $t('table.approvedAt') }}</th>
                        <th>{{ $t('table.loanNumber') }}</th>
                        <th>{{ $t('table.loan_credit_score') }}</th>
                        <th>{{ $t('table.amount') }}</th>
                        <th>{{ $t('table.loanType') }}</th>
                        <th>{{ $t('table.purposeLoan') }}</th>
                      </tr>
                    </thead>
                    <tbody />
                  </table>
                </div>
              </div>
            </div>
            <div class="col-md-12">
              <x-box
                :title="$t('string.commentList')"
                tool
              >
                <template slot="box-tools">
                  <button
                    class="btn btn-default btn-sm mr-2"
                    @click="onRefreshCommentList"
                  >
                    <i class="fa fa-refresh" /> {{ $t('string.refresh') }}
                  </button>
                  <button
                    class="btn btn-primary btn-sm"
                    data-toggle="modal"
                    @click="onAddNewComment"
                    v-if="can([Permissions.backend.comment.store])"
                    data-target="#createCommentModal"
                  >
                    {{ $t('string.addComment') }}
                  </button>
                </template>
                <comment-list
                  ref="commentList"
                  :borrow-id="parseInt($route.params.borrow_id)"
                />
              </x-box>
            </div>
          </div>
        </div>
      </div>
    </div>
    <loan-cancel-modal />
    <create-comment-modal
      :borrow-id="parseInt($route.params.borrow_id)"
    />
    <edit-comment-modal />
    <EditLoginAccountModal />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import LoanCancelModal from '@/views/borrows/_components/LoanCancelModal'
import CommentList from '@/views/comments/components/CommentList'
import CreateCommentModal from '@/views/comments/components/CreateCommentModal'
import EditCommentModal from '@/views/comments/components/EditCommentModal'
import EditLoginAccountModal from '@/views/borrows/_components/EditLoginAccountModal'
import Permissions from '@/permissions'

export default {
  name: 'Show',
  components: {
    EditLoginAccountModal,
    EditCommentModal,
    CreateCommentModal,
    CommentList,
    LoanCancelModal
  },
  metaInfo () {
    return {
      title: this.$t('string.showBorrower'),
      titleTemplate: '%s | ' + process.env.VUE_APP_NAME
    }
  },
  data () {
    return {
      oTable: null,
      client: {
        search_borrower_id: null,
        name: null,
        last_name: null,
        national_id_number: null,
        phone: null,
        email: null,
        marital_status: null,
        gender: null,
        date_of_birth: null,
        street_number: null,
        home_number: null,
        village: null,
        commune: null,
        district: null,
        province: null,
        how_long_have_been_living_there: null,
        borrow_education: null,
        school_name: null,
        graduate_year: null,
        study_major: null,
        source_of_information: null,
        source_of_information_other: null,
        membership: null,
        borrower_status: null,
        occupation: null,
        company_name: null,
        gross_monthly_income: null,
        company_type: null,
        company_contact_name: null,
        company_contact_phone: null,
        relative_name: null,
        relative_contact_phone: null,
        relative_type_other: null,
        bank_name: null,
        bank_account_number: null,
        facebook_name: null,
        facebook_link: null,
        collection_officer: null,
        type: null,
        purchase_item: null,
        purchase_item_other: null,
        purchase_total_price: null,
        credit_score: null,
        type_of_collateral: null,
        type_of_collateral_other: null
      },
      baseUrl: process.env.VUE_APP_API,
      Permissions,
      borrower_status: {
        instruction: null
      }
    }
  },
  computed: {
    ...mapGetters({
      reloadLoanTable: 'applicantCancel/getReloadLoanTable'
    }),
    user () {
      if (this.client && this.client.user) {
        return this.client.user
      }
      return null
    },
    borrower_photo () {
      if (this.client && this.client.borrower_photo) {
        return `${this.baseUrl}/${this.client.borrower_photo}`
      }
      return '/img/tmp_avatar.jpg'
    },
    borrower_national_id_photo () {
      if (this.client && this.client.borrower_national_id_photo) {
        return `${this.baseUrl}/${this.client.borrower_national_id_photo}`
      }
      return '/img/tmp_avatar.jpg'
    },
    borrower_employment_card_photo () {
      if (this.client && this.client.borrower_employment_card_photo) {
        return `${this.baseUrl}/${this.client.borrower_employment_card_photo}`
      }
      return '/img/tmp_avatar.jpg'
    }
  },
  watch: {
    '$i18n.locale': function () {
      if (this.oTable !== null) {
        this.oTable.destroy()
        this.oTable = this.dataTable()
        this.oTable.draw(true)
      }
    },
    reloadLoanTable () {
      if (this.reloadLoanTable) {
        this.oTable.draw(true)
      }
    }
  },
  methods: {
    onRefreshCommentList () {
      this.$store.commit('comment/setBorrowId', parseInt(this.$route.params.borrow_id))
      this.$store.commit('comment/setRefreshCommentList')
    },
    onAddNewComment () {
      this.$store.commit('comment/setBorrowId', parseInt(this.$route.params.borrow_id))
    },
    dataTable () {
      const self = this
      return $('#loans-table').DataTable({
        stateSave: true,
        processing: true,
        serverSide: true,
        scrollX: true,
        scrollCollapse: true,
        pageLength: process.env.VUE_APP_PAGE_LENGTH,
        lengthMenu: this.$lengthMenu,
        ajax: {
          method: 'POST',
          url: process.env.VUE_APP_API + '/api/v1/client/datatable-loans',
          data: (d) => {
            d.borrow_id = self.$route.params.borrow_id
          },
          error: (xhr) => {
            this.onAccessDenied(xhr)
          }
        },
        columns: [
          {
            data: 'action',
            name: 'action',
            title: this.$t('table.action'),
            orderable: false,
            searchable: false
          },
          {
            data: 'approved_at',
            name: 'approved_at',
            title: this.$t('table.approvedAt')
          },
          {
            data: 'search_loan_id',
            name: 'search_loan_id',
            title: this.$t('table.loanNumber')
          },
          {
            data: 'loan_credit_score',
            name: 'loan_credit_score',
            title: this.$t('table.loan_credit_score'),
            render: (data) => data || this.$t('string.na')
          },
          {
            data: 'amount',
            name: 'amount',
            title: this.$t('table.amountApproved')
          },
          {
            data: 'loan_type',
            name: 'loan_type',
            title: this.$t('table.loanType')
          },
          {
            data: 'purpose_loan.name',
            name: 'purposeLoan.name',
            title: this.$t('table.purposeLoan'),
            render: (data, type, row) => {
              if (row.purpose_loan) {
                return row.purpose_loan.name
              }
              return this.$t('string.na')
            }
          }
        ],
        order: [
          [1, 'desc']
        ],
        language: {
          url: `/locale/${this.$i18n.locale}.json`
        }
      })
    },
    async getClient () {
      await this.$axios.post(process.env.VUE_APP_API + '/api/v1/client/show', {
        borrow_id: this.$route.params.borrow_id
      }).then((response) => {
        if (response.data.code === 1) {
          this.client = response.data.data
        }
      })
    },
    getBorrowerStatus () {
      const { borrower_status } = this.client
      if (!borrower_status) {
        return 0
      }
      this.$axios.get(`${process.env.VUE_APP_API}/api/v1/borrower-statuses/${borrower_status}`)
        .then(({ data }) => {
          if (data.data) {
            this.borrower_status = data.data
          }
        })
    },
    onSyncLoans () {
      this.$isLoading(true)
      this.$axios.post(process.env.VUE_APP_API + '/api/v1/loan/sync-loan-by-borrower', {
        borrow_id: this.$route.params.borrow_id
      }).then((response) => {
        if (response.data.code === 1) {
          this.$toastr('success', this.$t('string.theRequestHaveBeenProcessed'), this.$t('string.success'))
          this.oTable.draw()
        } else {
          this.$toastr('error', response.data.message, this.$t('string.error'))
        }
      }).finally(() => {
        this.$isLoading(false)
      })
    },
    onDeleteLoan (loan_id) {
      this.$swal({
        title: this.$t('string.areYouSure?'),
        text: this.$t('string.youWillNotBeRevert'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('string.yesIDeleteIt!'),
        cancelButtonText: this.$t('string.cancel')
      }).then((result) => {
        if (result.value) {
          this.$isLoading(true)
          this.$axios.post(process.env.VUE_APP_API + '/api/v1/loan/delete', {
            loan_id: loan_id
          }).then((response) => {
            if (response.data.code === 1) {
              this.oTable.draw(true)
              this.$toastr('success', this.$t('string.theRequestHaveBeenProcessed'), this.$t('string.success'))
            } else {
              this.$toastr('error', response.data.message, this.$t('string.error'))
            }
          }).catch(({ response }) => {
            this.$toastr('error', response.data.message, this.$t('string.error'))
          }).finally(() => {
            this.$isLoading(false)
          })
        }
      })
    },
    loanActions () {
      this.clearEventHandlers([
        '.btn-delete-loan',
        '.btn-cancel-loan'
      ])
      const self = this
      $(document).on('click', '.btn-delete-loan', function () {
        self.onDeleteLoan($(this).attr('data-loan-id'))
      })
      $(document).on('click', '.btn-cancel-loan', function () {
        self.$store.commit('applicantCancel/SET_LOAN_SELECTED', $(this).attr('data-loan-id'))
      })
    }
  },
  async mounted () {
    this.oTable = this.dataTable()
    this.loanActions()
    await this.getClient().then(() => {
      this.getBorrowerStatus()
    })
  },
  beforeDestroy () {
    this.oTable.clear()
    this.oTable.destroy()
  }
}
</script>

<style scoped>
</style>
